/* ========== ~~~~~~~~~~ FORM DATA: ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_MULTIPLE_FORM_FIELDS = 'UPDATE_MULTIPLE_FORM_FIELDS';
export const ACTIVATE_FIELD = 'ACTIVATE_FIELD';
export const DEACTIVATE_FIELD = 'DEACTIVATE_FIELD';


// update store with new page values based on some cta to navigate
// this gets batched with changePage and is called directly before that action
export const updateFormData = (field, value, valid) => ({
    type: UPDATE_FORM_DATA,
    field,
    value,
    valid
});
export const updateMultipleFormFields = formData => ({
    type: UPDATE_MULTIPLE_FORM_FIELDS,
    formData
});
export const activateField = (field) => ({
    type: ACTIVATE_FIELD,
    field
});
export const deactivateField = (field) => ({
    type: DEACTIVATE_FIELD,
    field
});